(() => {
  const CLOSE_MS = 400;

  class MJFacetsDrawer extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.details = this.querySelector(':scope > details');
      if (!this.details) return;

      this.onClick = this.onClick.bind(this);
      this.onKeyUp = this.onKeyUp.bind(this);
      this.onToggle = this.onToggle.bind(this);

      this.addEventListener('click', this.onClick);
      this.addEventListener('keyup', this.onKeyUp);
      this.details.addEventListener('toggle', this.onToggle);
      this.syncOpenState();
    }

    get mainSummary() {
      return this.details?.querySelector(':scope > summary');
    }

    open() {
      if (!this.details || this.details.open) {
        this.syncOpenState();
        return;
      }
      this.details.open = true;
    }

    close() {
      if (!this.details?.open) return;
      this.details.classList.remove('menu-opening');
      this.unlockPage();
      window.setTimeout(() => {
        if (this.details) this.details.open = false;
      }, CLOSE_MS);
    }

    lockPage() {
      if (this.pageLocked) return;
      this.pageLocked = true;
      this.lockedScrollY = window.scrollY || document.documentElement.scrollTop || 0;
      document.body.style.top = `-${this.lockedScrollY}px`;
      document.documentElement.classList.add('mj-facets-lock');
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint || 'desktop'}`);
    }

    unlockPage() {
      if (!this.pageLocked) return;
      const y = this.lockedScrollY || 0;
      this.pageLocked = false;
      this.lockedScrollY = 0;
      document.documentElement.classList.remove('mj-facets-lock');
      document.body.style.top = '';
      document.body.classList.remove('overflow-hidden-desktop', 'overflow-hidden-mobile');
      window.scrollTo(0, y);
    }

    syncOpenState() {
      if (!this.details) return;

      if (this.details.open) {
        requestAnimationFrame(() => {
          this.details.classList.add('menu-opening');
        });
        this.lockPage();
        this.mainSummary?.setAttribute('aria-expanded', 'true');
      } else {
        this.details.classList.remove('menu-opening');
        this.unlockPage();
        this.mainSummary?.setAttribute('aria-expanded', 'false');
      }
    }

    onToggle() {
      this.syncOpenState();
    }

    onClick(event) {
      const mainSummary = this.mainSummary;
      if (mainSummary && mainSummary.contains(event.target)) {
        if (this.details.open) {
          event.preventDefault();
          this.close();
        }
        return;
      }

      if (event.target.closest('.mj-facets-close, .mobile-facets__close')) {
        event.preventDefault();
        this.close();
        return;
      }

      if (event.target.classList.contains('mobile-facets')) {
        this.close();
      }
    }

    onKeyUp(event) {
      if (event.code !== 'Escape') return;
      this.close();
    }

    bindEvents() {
      this.syncOpenState();
    }
  }

  if (!customElements.get('mj-facets-drawer')) {
    customElements.define('mj-facets-drawer', MJFacetsDrawer);
  }

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-mj-facets-toggle]');
    if (!toggle) return;

    const dropdown = toggle.closest('.mj-facets-dropdown');
    if (!dropdown) return;

    const collapsed = dropdown.classList.toggle('mj-facets-dropdown--collapsed');
    toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
  });
})();
